import { render, staticRenderFns } from "./DokuWikiWrapper.vue?vue&type=template&id=13e3c219&scoped=true"
import script from "./DokuWikiWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./DokuWikiWrapper.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DokuWikiWrapper.vue?vue&type=style&index=0&id=13e3c219&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13e3c219",
  null
  
)

export default component.exports